import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

import AiIntegrationsBulkActionsConfirmActionForm from "./ConfirmActionForm";
import AiIntegrationsBulkActionsSelectedItem from "./SelectedIntegrationItem";
import {
  AiIntegrationsBulkActionsAnalyticsPayload,
  AiIntegrationsBulkActionItem,
  AiIntegrationsMutationVariables,
} from "./types";

type AiIntegrationsBulkActionsConfirmationViewProps = {
  applicableItems: AiIntegrationView[];
  skippedItems: AiIntegrationView[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: AiIntegrationsBulkActionItem;
  onConfirm: (
    mutationVariables: AiIntegrationsMutationVariables,
    analyticsPayload: AiIntegrationsBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
};

const AiIntegrationsBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
}: AiIntegrationsBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <AiIntegrationsBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <AiIntegrationsBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default AiIntegrationsBulkActionsConfirmationView;
